import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs';
import Ticket from 'src/app/core/models/ticket.model';
import { TicketService } from 'src/app/core/service/tickets/tickets.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-vote-ticket',
  templateUrl: './vote-ticket.component.html',
  styleUrls: ['./vote-ticket.component.scss']
})
export class VoteTicketComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() next = new EventEmitter<any>();

  pagination = { currentPage: 1, totalPages: 1 };
  filteredTickets: Ticket[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tickets: any[] = [];
  noTicketsFound = false;
  pageSize = 5;
  isMobile = false;
  page = 1;
  searchTicket = '';
  votedItems = new Set<number>();
  votedTicketNumbers: number[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any[] = [
    { header: 'Ticket', field: 'ticketToVote' },
    { header: 'Votes', field: 'votes' },
    { header: '', field: 'template' }
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columnsM: any[] = [
    { header: 'Ticket', field: 'ticketToVote' },
    { header: '', field: 'template' }
  ];

  searchBarForm: FormGroup = new FormGroup({
    searchTicket: new FormControl('', [Validators.required])
  });

  constructor(private ticketService: TicketService, private deviceDetectorService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.checkIfMobile();
    this.loadTicketsForVote();

    this.searchBarForm.controls['searchTicket'].valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        filter((searchTicket) => searchTicket && searchTicket.length === 10)
      )
      .subscribe((searchTicket) => {
        this.searchTicket = this.formatTicketNumber(searchTicket);
        this.page = 1;
        this.pageSize = 5;
        this.loadTicketsForVote();
      });

    this.searchBarForm.controls['searchTicket'].valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        filter((searchTicket) => !searchTicket)
      )
      .subscribe(() => {
        this.searchTicket = '';
        this.loadTicketsForVote();
      });

  }

  private checkIfMobile(): void {
    this.isMobile = this.deviceDetectorService.isMobile();
  }

  isVoted(num: number): boolean {
    return this.votedItems.has(num);
  }

  onVote(num: number, ticket: number[]): void {
    if (!this.votedItems.has(num)) {
      this.votedItems.add(num);
      this.votedTicketNumbers.push(...ticket);
      setTimeout(() => {
        this.next.emit(this.votedTicketNumbers)
      }, 2000);
    }
  }

  onPageChange(page: number): void {
    this.page = page
    this.loadTicketsForVote();
  }

  loadTicketsForVote(): void {
    this.ticketService.getTickets(this.page, this.pageSize, this.searchTicket).subscribe((response) => {

      this.tickets = response.content.map(t => ({
        ...t,
        ticketToVote: t.number.split('-')
      }))
      this.noTicketsFound = this.tickets.length === 0;
      this.pagination = {
        currentPage: this.page,
        totalPages: Math.ceil(response.pageInfo.totalItems / this.pageSize),
      }
    })
  }

  formatTicketNumber(ticket: string): string {
    return ticket.replace(/(\d{2})(?=\d)/g, '$1-');
  }



}
